<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="customersComputed"
              :items-per-page="defaultPageSize"
              item-key="id"
              sort-by="reminder.urgency"
              :sort-desc=true
              click:column="goToDetails" 
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Customers</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <template>

                    <v-layout  row wrap>  
                      <v-flex xs1 align-self-center="true">  
                        <Xlsx filename="customers" :items="xlsxItems"  :headers="xlsxHeaders" />                                      
                      </v-flex>
                      <v-flex xs3>
                        <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                      </v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="searchCustomers()" >Search</v-btn></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="clearSearch()" >Clear</v-btn></v-flex>
                      <v-flex xs2 align-self-baseline="right">
                        <v-combobox
                          :items="tagsList"
                          label="Filter By Tag"
                          v-model="selectedTagFilter"
                          item-text="text"
                          multiple
                          chips
                          return-object
                        ></v-combobox> 
                      </v-flex>
                      <v-flex xs1 align-self-baseline="center">
                        <v-icon                  
                          @click="getCustomers(1, defaultPageSize)">
                          mdi-refresh
                        </v-icon>
                      </v-flex> 
                      <v-flex xs2>
                        <v-btn color="primary" dark class="mb-2" @click="createNewCustomer()">New Customer</v-btn>
                      </v-flex>
                       <v-flex xs1>
                        <v-btn color="primary" dark class="mb-2" @click="showActivityDialog()">Activity</v-btn>
                      </v-flex>
                    </v-layout>

                  </template>
                  <v-dialog v-model="dialog" max-width="900px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md12>
                              <v-text-field v-model="editedItem.customerName" label="Customer Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                              <v-text-field v-model="editedItem.company" label="Company"></v-text-field>
                            </v-flex>   
                            <v-flex xs12 sm6 md6>
                               <v-combobox
                                :items="countryList"
                                label="Select Country"
                                v-model="editedItem.country"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>                                                                                   
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6> 
                               <v-combobox
                                :items="getNumbers(1,10)"
                                label="Status"
                                v-model="editedItem.status"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                              <v-combobox
                                :items="getCustomerTypes()"
                                label="Customer Type"
                                v-model="editedItem.type"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md9>
                              <v-combobox
                                :items="tagsList"
                                label="Select tags"
                                v-model="editedItem.tags"
                                item-text="text"
                                multiple
                                chips
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.notes"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Notes"></v-textarea>
                            </v-flex> 
                                                        
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>


                  <v-dialog v-model="expiredActivitiesDialog" max-width="1300px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">Customers with Expired Reminders </span> 
                        <v-flex xs1/>
                        <v-flex xs12 sm6 md2>
                            <v-combobox
                            :items="typeList"
                            label="Select Type"
                            v-model="selectedActivityType"
                            item-text="text"
                            disabled
                            single-line
                            return-object
                            ></v-combobox>
                        </v-flex> 
                        <v-flex xs3 align-self-baseline="right">
                          <v-combobox
                            :items="tagsList"
                            label="Filter By Tag"
                            v-model="selectedActivityCustomerTag"
                            item-text="text"
                            chips
                            return-object
                          ></v-combobox> 
                        </v-flex>
                        <v-flex xs1 align-self-baseline="center">
                          <v-icon                  
                            @click="filterExpiredActivities">
                            mdi-refresh
                          </v-icon>
                        </v-flex> 
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>     
                            <v-flex xs12 sm6 md2>                              
                                <DatePicker picker-label="Remind Date" :date-value="bulkActivityItem.remindDate" @dateSelected="bulkActivityItem.remindDate=$event" /> 
                            </v-flex>     
                            <v-flex xs12 sm6 md2>
                              <v-combobox
                                :items="personnelsList"
                                label="Select Personnels"
                                v-model="bulkActivityItem.personnels"
                                item-text="name"
                                multiple
                                chips
                                return-object
                              >
                                <template slot="item" slot-scope="data">
                                  {{ data.item.name }}  {{ data.item.surname }}
                                </template>
                              </v-combobox>
                            </v-flex>  
                            <v-flex xs12 sm6 md2>
                              <v-text-field v-model="bulkActivityItem.header" label="Header"></v-text-field>
                          </v-flex> 
                            <v-flex xs12 sm6 md5>
                             <v-text-field v-model="bulkActivityItem.explanation" label="Explanation"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md1>     
                              <v-btn color="success" dark class="mb-2" @click="createBulkActivities">Create</v-btn>     
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                              
                               <v-data-table
                                v-model="selectedExpiredCustomers"
                                :headers="expiredActivitiesHeaders"
                                :items="expiredActivitiesFormatted"
                                :items-per-page="100"
                                show-select
                                item-key="customerName"
                                sort-by="remindDate"
                                class="elevation-1"
                                >                      
                              </v-data-table>

                            </v-flex>                                                                                                                                                                                                                                  
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeExpiredActivitiesDialog">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-toolbar>
              </template> 
              <template v-slot:body.append>                    
              </template>          
              <template v-slot:footer>       
                <Pagination  :record-count="recordCount" :default-page-size="defaultPageSize"
                       @pageNumberChanged="pageNumberChanged($event)" @pageSizeChanged="pageSizeChanged($event)" />             
              </template> 
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
              </template>
              <template v-slot:item.customerName="{ item }">                 
                <a  @click.prevent="goToDetails(item)" :class="getCustomerColor(item)"
                >{{ item.customerName}}</a>    
              </template> 
              <template v-slot:item.goToDetails="{ item }">      
                <v-badge
                  v-if="item.showNotificationBadge"
                  bordered
                  :color="getReminderColor(item.reminder)"
                  icon="mdi-bell"
                  overlap
                >
                  <v-icon                  
                  @click="goToDetails(item)">
                  mdi-send
                  </v-icon>
                </v-badge>    
                <v-icon        
                  v-if="!item.showNotificationBadge"        
                  @click="goToDetails(item)">
                  mdi-send
                  </v-icon>             
              </template>     
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import Pagination from '../../components/Pagination';
import Progress from '../../components/Progress';
import Xlsx from '../../components/Xlsx';
import DatePicker from '../../components/DatePicker';
const API_URL = 'definitions/customers';
const COUNTRIES_API_URL = 'definitions/countries';
const CATEGORIES_URL = 'definitions/productCategories';
const PERSONNELS_URL = 'definitions/personnelReduced/status/'
const CUSTOMER_ACTIVITY_TYPES_API_URL = 'definitions/customerActivityTypes';
export default {
    components:{
      LeftMenu,
      Pagination,
      Progress,
      DatePicker,
      Xlsx
    },
    data () {
    return {
      dialog: false,
      showProgress : false,
      expiredActivitiesDialog : false,
      search: '',
      typeList: [],
      expiredActivities : [],
      selectedExpiredCustomers : [],
      countryList: [],
      personnelsList: [],
      tagsList: [],
      customers: [],
      selectedTagFilter: [],
      selectedActivityCustomerTag: {id:0},
      selectedActivityType : {},
      editedIndex: -1,
      bulkActivityItem: {
        remindDate: '',
        header: 'FOLLOW UP',
        explanation: ''
      },
      editedItem: {
        customerName: '',
        country: '',
        status: '',
        company:'',             
        email:'',
        phone:'',
        notes:'',
      },
      defaultItem: {
        customerName: '',
        country: '',
        status: '',
        company:'',             
        email:'',
        phone:'',
        notes:'',
      },
      xlsxHeaders: {
        id : 'Customer Id' ,
        customer : 'Customer Name Surname' ,
        country : 'Country' ,
        company : 'Company'  ,      
        email : 'Email' ,        
        tags : 'Tags' ,
        notes : 'Notes'  
      },
      defaultPageSize : 25,
      recordCount : 0,
    }
  },
  computed: {
    headers () {
      return [
        { text: '',align: 'left',sortable: false,value: 'goToDetails'},
        { text: 'ID',align: 'left',sortable: true,value: 'id'},
        { text: 'Customer',align: 'left',sortable: true,value: 'customerName'},
        { text: 'Country',  value: 'country.name'  },
        { text: 'Status',  value: 'status'  },
        { text: 'Company',  value: 'company'  },
        { text: 'Email',  value: 'email'  },
        { text: 'Tags',  value: 'tagsFormatted'  },
        { text: 'Notes',  value: 'noteSummary'  },
        { text: 'Operations', value: 'action', sortable: false },
      ]
    },
    expiredActivitiesHeaders () {
      return [
        { text: 'ReminderDate',  value: 'remindDate'  },
        { text: 'Customer Name',  value: 'customerName'  },          
        { text: 'Country',  value: 'country.name'},
        { text: 'Company',  value: 'company'  },   
        { text: 'Tags',  value: 'tagsFormatted'  },          
        { text: 'Notes',  value: 'noteSummary'  },        
        { text: 'Email',  value: 'email'  }
      ]
    }, 
    xlsxItems(){
      return this.customersComputed.map((item) => {
        return {
          id: item.id,
          customer: item.customerName,
          country: item.country.name,
          company: item.company,
          email: item.email ,
          tags: item.tagsFormatted,
          notes: item.notes              
        }
      });
    },
    customersComputed(){
      return this.customers.map((item) => {
        item.tagsFormatted = item.tags ? item.tags.map(e => e.text).join(' - ') : '';
        item.noteSummary = item.notes.substr(0,80);
        item.showNotificationBadge = item.reminder ? (item.reminder.expiredCount>0 || item.reminder.upcomingCount>0) : false ;
        return item;  
      })
    },
    expiredActivitiesFormatted(){
      return this.expiredActivities.map((item) => {
        item.tagsFormatted = item.tags ? item.tags.map(e => e.text).join(' - ') : '';
        item.noteSummary = item.notes.substr(0,80);
        return item;  
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Customer' : 'Edit Customer'
    },
  },
  created() {    
    this.getTags();
    this.getCustomers(1, this.defaultPageSize);
    this.getCountries();
    this.getActivityTypes();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    expiredActivitiesDialog(val){
      val || this.closeExpiredActivitiesDialog()
    },
  },
  methods: {
    showActivityDialog(){
      this.getPersonnels();
      this.getExpiredActivityCustomers();
    },
    getExpiredActivityCustomers(){
      this.selectedActivityType = (this.typeList.filter(type => type.code == 'FOLLOWUP'))[0];
      if(!this.selectedActivityCustomerTag){
        this.selectedActivityCustomerTag = {id:0};
      }
      this.$axios.get(this.$apiurl + API_URL +"/expiredActivities/"+this.selectedActivityType.id+"/"+this.selectedActivityCustomerTag.id)
            .then(response => {
                this.expiredActivities = response.data;
                this.expiredActivitiesDialog = true;
            }) 
            .catch(error => {
                console.log(error);
            });   
    },
    closeExpiredActivitiesDialog(){
      this.expiredActivitiesDialog = false;
    },
    createBulkActivities(){
      if(!this.selectedExpiredCustomers || this.selectedExpiredCustomers.length ==0){
        alert('Please select customers from table!');
        return;
      }

      if(!this.bulkActivityItem.remindDate){
        alert('Please select remind date!');
        return;
      }

      if(!this.bulkActivityItem.personnels){
        alert('Please select personnels!');
        return;
      }
      if(!this.bulkActivityItem.header){
        alert('Please write header!');
        return;
      }
      if(!this.bulkActivityItem.explanation){
        alert('Please write explanation!');
        return;
      }

      const customerCount = this.selectedExpiredCustomers.length;
      if(confirm('Are you sure you want to create activity for '+customerCount+' customers?')){
        this.postBulkActivities();
      } 

    },
    postBulkActivities(){
      this.$axios.post(this.$apiurl + API_URL +"/expiredActivities/", {
        customers: Array.from(this.selectedExpiredCustomers,x => x.customerId), 
        activities: Array.from(this.selectedExpiredCustomers,x => x.activityId), 
        remindDate: this.bulkActivityItem.remindDate,
        activityDate: this.bulkActivityItem.remindDate,
        reminder: 1,
        typeId : this.selectedActivityType.id,
        personnels : this.bulkActivityItem.personnels ? Array.from(this.bulkActivityItem.personnels,x => x.id) : null,
        header: this.bulkActivityItem.header,
        explanation: this.bulkActivityItem.explanation,
      })
      .then(response => {
        if (response.status === 200) {
          this.getExpiredActivityCustomers();
          this.selectedExpiredCustomers.splice(0, this.selectedExpiredCustomers.length); 
          this.close();
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    clearSearch(){
      this.search = '';
      this.getCustomers(1, this.defaultPageSize);
    },
    filterExpiredActivities(){
      this.getExpiredActivityCustomers();
    },
    searchCustomers(){
      if(!this.search || this.search.length < 3){
        alert('Type at least 3 characters to search!');
        return;
      }
      this.showProgress = true;
      var url = this.$apiurl + API_URL +"/search/"+this.search;
      this.$axios.get(url)
        .then(response => {
            this.customers = response.data;
            this.recordCount = response.data.length;
            this.showProgress = false;
        }) 
        .catch(error => {
            console.log(error);
        });
    },
    createNewCustomer(){
      this.dialog = true;
    },
    pageSizeChanged(pageSize){
      this.defaultPageSize = pageSize;
      this.getCustomers(1, pageSize);
    },
    getActivityTypes(){     
        this.$axios.get(this.$apiurl + CUSTOMER_ACTIVITY_TYPES_API_URL)
            .then(response => {
                this.typeList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    pageNumberChanged(pageNumber){
      this.getCustomers(pageNumber, this.defaultPageSize);
    },
    filterCustomers (){
      var selectedFilters = [];
      if(this.selectedTagFilter){         
        selectedFilters = Array.from(this.selectedTagFilter, x => x.id);
        this.getCustomersByTag(selectedFilters);
      }
    },
    getPersonnels(){     
        this.$axios.get(this.$apiurl + PERSONNELS_URL + true)
            .then(response => {
                this.personnelsList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getStatusColor (status) {
      if(status == '') return ''
      else if (status > 8) return '#2E7D32'
      else if (status > 6) return 'green'
      else if (status > 4) return 'cyan'
      else if (status > 2 ) return 'orange'
      else return 'red'
    },
    getReminderColor (reminder) {
      if(!reminder) return ''
      else if (reminder.expiredCount>0) return 'red'
      else if (reminder.upcomingCount>0) return 'orange'
      else return 'red'
    },
    getNumbers:function(start,stop){
        return new Array(stop-start).fill(start).map((n,i)=>n+i);
    },
    getCustomerTypes(){
      return new Array("PUBLIC", "PRIVATE");
    },
    goToDetails(item){
      //this.$router.push('/customers/'+item.id);
      const routeData = this.$router.resolve('/customers/'+item.id);
      window.open(routeData.href, '_blank');
    },
    getTags(){     
        this.$axios.get(this.$apiurl + CATEGORIES_URL)
            .then(response => {
                this.tagsList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    editItem (item) {
      this.editedIndex = this.customers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.customers.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.customers.splice(index, 1);
        this.deleteCustomer(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if(!this.editedItem.customerName){
        alert('Customer Name cannot be empty!');
        return;
      } 
      
      if(!this.editedItem.company){
        alert('Company cannot be empty!');
        return;
      }  

      if(!this.editedItem.country){
        alert('Country cannot be empty!');
        return;
      }  

      if(!this.editedItem.type){
        alert('Customer Type cannot be empty!');
        return;
      }  

      if (this.editedIndex > -1) {        
        this.updateCustomer(this.editedItem);
      } else {
        this.addCustomer(this.editedItem);         
      }      
    },
    addCustomer(item){
      this.$axios.post(this.$apiurl + API_URL, {
        customerName: item.customerName,
        countryId: item.country ? item.country.id : null,
        status: item.status,
        type : item.type,
        company: item.company,
        email: item.email,
        phone: item.phone,
        tags : item.tags ? Array.from(item.tags,x => x.id) : null,
        notes: item.notes
      })
      .then(response => {
        if (response.status === 201) {
          this.customers.push(this.editedItem);
          this.getCustomers(1, this.defaultPageSize);
          this.close();
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateCustomer(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        customerName: item.customerName,
        countryId: item.country ? item.country.id : null,
        status: item.status,
        type : item.type,
        company: item.company,
        email: item.email,
        phone: item.phone,
        tags : item.tags ? Array.from(item.tags,x => x.id) : null,
        notes: item.notes
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.customers[this.editedIndex], this.editedItem);
          this.getCustomers(1, this.defaultPageSize);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteCustomer(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCustomers(pageNumber, pageSize){   
      this.showProgress = true;
      var url = this.$apiurl + API_URL;  
      url += "/paginated";

      var selectedFilters = [];
      if(this.selectedTagFilter){         
        selectedFilters = Array.from(this.selectedTagFilter, x => x.id);
      }  
      this.$axios.post(url , { 
            pageSize : pageSize,
            pageNum : pageNumber,  
            tags : selectedFilters                 
          })
          .then(response => {
              this.customers = response.data.customerList;
              this.recordCount = response.data.allCustomerCount;
              this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    getCustomersByTag(selectedFilters){
      this.$axios.post(this.$apiurl + API_URL+"/filter/tags", {   
            tags : selectedFilters                 
          })
          .then(response => {
            this.customers = response.data
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getCountries(){     
        this.$axios.get(this.$apiurl + COUNTRIES_API_URL)
            .then(response => {
                this.countryList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCustomerColor(item){
      return 'customerNormal';
    },
  },
}
</script>
</script>
<style scoped>
.paymentNotReceived{
  color:red;
}
.customerNormal{
    color:blue;
  }
</style>
